import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Booking } from '../../booking/booking'
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { bookingSelectors } from '../../booking/booking.selectors'
import { Observable, Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { AppState } from '../../../core/core.state'
import { Constants } from '../../../shared/constants'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { Dictionary } from '@ngrx/entity'
import { Product } from '../../product/product'
import { productSelectors } from '../../product/product.selectors'

@UntilDestroy()
@Component({
  selector: 'booking-select-input',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BookingSelectInput),
      multi: true
    }
  ]
})
export class BookingSelectInput implements OnInit, ControlValueAccessor {
  @Input() bookings: Booking[]
  @Input() allowClearing: boolean = false
  @Input() isDisabled: boolean = false
  @Output() search = new EventEmitter<string>()

  public isLoading$: Observable<boolean>
  public value = null
  public disabled = false
  private bookingTypeahead$ = new Subject<string>()
  public productEntities: Dictionary<Product>

  constructor(private store: Store<AppState>) {}

  public onChange: any = () => {}

  public onTouched: any = () => {}

  ngOnInit() {
    this.isLoading$ = this.store.select(bookingSelectors.selectIsLoading)

    this.bookingTypeahead$
      .pipe(
        distinctUntilChanged(),
        debounceTime(DEBOUNCED_TIME),
        untilDestroyed(this),
        filter((s) => s.length > 2)
      )
      .subscribe((term) => {
        this.search.emit(term)
      })

    this.store
      .select(productSelectors.selectEntities)
      .pipe(untilDestroyed(this))
      .subscribe((productEntities) => (this.productEntities = productEntities))
  }

  public onChangeValue(booking: Booking | null) {
    if (!booking) {
      return this.onChange(null)
    }

    this.onChange(booking.id)
  }

  public selectSearch(term: string, booking: Booking) {
    // TODO: return linkedProductId.desc + product.desc + booking date
    return this.productEntities[booking?.linkedProductId]?.description
      .toLowerCase()
      .includes(term.toLowerCase())
  }

  // ControlValueAccessor interface functions below here
  public writeValue(value: number): void {
    this.value = value
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  public onSearch(event: { term: string; items: Booking[] }) {
    this.bookingTypeahead$.next(event.term)
  }
}
